<template>
   <section class="checkout-section room-info-section" :class="!rooms.length ? 'data-mask' : ''">
      <div id="validation-error-auto-scroller"></div>
      <div class="checkout-section-inner room-info-card">
         <div class="checkout-section-title masked">
            <h4>{{ $t("hotelCheckout_lblRoomInfo") }} - {{ hotelName }}</h4>
         </div>
         <RoomInfoCardSkeleton v-if="!rooms.length" />
         <RoomInfoCard
            @startupGetAddons="startupGetAddons"
            @handleUpdateAddons="handleUpdateAddons"
            :searchedRoom="roomsList"
            v-for="(roomItem, index) in roomsList"
            :key="index"
            :roomIndex="index"
            :room="roomItem"
            :contactModel="contactModel"
            :customerNationality="customerNationality"
            :lastBookingDate="lastBookingDate"
            :checkinDate="checkinDate"
            :checkoutDate="checkoutDate" />
      </div>

      <Insurance v-if="insuranceOffers && !partialPaymentActive" @insurance-selected="handleSelectedInsurance" mode="checkout" :insuranceOffers="insuranceOffers" />

      <template v-if="$store.state.hotel.isCheckoutPageLoaded">
         <div class="room-alert-wrapper" v-if="!partialPaymentActive">
            <Alert status="alert" v-if="lastBookingDate != null">
               <i class="gts-icon icon-triangular-info icon-lg"></i>
               <div class="room-alert-inner">
                  <p>
                     {{ $t("hotelCheckout_lblLastBookingDate") }}
                     <span v-if="!partialPaymentActive">{{ lastBookingDate | FormatterDate }} {{ lastBookingDate | TimeFormat }}</span>
                     <span v-else>{{ formattedFirstPaymentDate }}</span>
                  </p>
                  <p>{{ $t("hotelCheckout_lblLastBookingDateDescription") }}</p>
               </div>
            </Alert>
         </div>
         <div v-else>
            <GtsInfoWidgetWBorder
               v-if="partialPaymentActive"
               class="WBorder-Widget"
               icon="gts-icon icon-partial-payment-shadow"
               :title="$t('orderDetail_PartialPaymentDeadLineTitle')"
               :text="formattedPartialPaymentLastBookingDate"
               :ishtmlContent="true"
               :contentBody="replacePartialPaymentDeadLineBody">
            </GtsInfoWidgetWBorder>
            <GtsInfoWidgetWBorder
               v-if="partialPaymentActive"
               class="WBorder-Widget-2nd"
               icon="gts-icon icon-partial-payment-shadow"
               :title="$t('orderDetail_PartialCancellationPolicy')"
               :ishtmlContent="true"
               :contentBody="replaceCancellationPolicies">
            </GtsInfoWidgetWBorder>
         </div>
         <div class="checkout-section-inner room-info-cancellation-policies">
            <div v-if="!partialPaymentActive">
               <CancellationPolicies className="hotel-checkout-cancellation-policies-wrapper" :cancellationDate="cancellationPolicyDate" :policies="cancellationPolicy" />
            </div>
            <div></div>
         </div>
      </template>
      <div class="checkout-section-inner room-info-price row">
         <PriceWidget
            @commission-update="handlerAddCommission"
            @getAgencyCommisions="getAgencyCommisions"
            showCommission
            :countryCode="CountryCode"
            :totalTax="totalTax"
            :taxInformation="handlerRoomTax"
            :totalPriceInfo="TotalPriceInfo"
            checkoutMode
            label="hotelCheckout" />
      </div>
   </section>
</template>

<script>
import Popup from "@/gts-popup.js";
import { hotelService } from "@/service/index.js";
import moment from "moment";

import RoomInfoCard from "@/components/structural/hotel/checkout/RoomInfoCard.vue";
import RoomInfoCardSkeleton from "@/components/structural/hotel/checkout/RoomInfoCardSkeleton.vue";
import CancellationPolicies from "@/components/structural/hotel/common/CancellationPolicies.vue";
import PriceWidget from "@/components/unitary/PriceWidget.vue";
import Alert from "@/components/unitary/Alert.vue";
import GtsInfoWidgetWBorder from "@/components/utils/GtsInfoWidgetWBorder.vue";
import Insurance from "@/components/unitary/Insurance.vue";
// import UIModal from "@/components/unitary/form2/UIModal.vue";
// import CheckoutPartialPaymentDetails from "./CheckoutPartialPaymentDetails.vue";

export default {
   name: "RoomInfo",
   props: {
      partialPaymentCancellationPolicy: { type: Array },
      partialPaymentLastBookingDate: { type: String },
      countryCode: { type: String },
      contactModel: { type: Object },
      customerNationality: { type: String },
      roomsList: { type: Array },
      totalPriceInfo: { type: Object },
      providerPriceInfo: { type: Object },
      cancellationPolicies: { type: Array },
      cancellationPoliciesDate: { type: String },
      checkinDate: { type: String },
      checkoutDate: { type: String },
      lastBookingDate: { type: String },
      totalTax: { type: Number },
      checkoutUuidProps: { type: String },
      searchUuidProps: { type: String },
      partialPaymentModel: { type: Array },
      partialPaymentDateUpdate: Boolean,
      partialPaymentActive: { type: Boolean, default: false },
      insuranceOffers: { type: Array },
   },
   components: {
      // CheckoutPartialPaymentDetails,
      RoomInfoCard,
      PriceWidget,
      CancellationPolicies,
      RoomInfoCardSkeleton,
      Insurance,
      Alert,
      GtsInfoWidgetWBorder,
      // UIModal,
   },
   data() {
      return {
         agencyCommisionsModel: {},
         isFirstRender: true,
         roomsPaxes: [],
         rooms: [],
         providerInfo: {
            priceViewType: 1,
            baseRate: 0,
            tax: 0,
            providerTotal: 0,
            cityTax: 0,
         },
         checkoutRequestModel: {
            selectedAddOns: {},
            searchUuid: "",
            refreshCheckout: false,
            basketUuid: "",
            selectedInsurance: null,
            trxType: 1,
            agencyCommissionExtra: 0,
            agencyCommissionRatio: 0,
            rooms: [],
         },
      };
   },
   computed: {
      handlerRoomTax() {
         const aggregatedTaxes = {};

         this.roomsList.forEach((room) => {
            if (room.taxes && Array.isArray(room.taxes)) {
               room.taxes.forEach((tax) => {
                  const key = `${tax.name}_${tax.currency}_${tax.includedBySupplier}`;
                  if (aggregatedTaxes[key]) {
                     aggregatedTaxes[key].amount += tax.amount;
                  } else {
                     aggregatedTaxes[key] = { ...tax };
                  }
               });
            }
         });

         return Object.values(aggregatedTaxes);
      },
      replacePartialPaymentDeadLineBody() {
         var firstDepositPriceText = this.$options.filters.price(this.partialPaymentCancellationPolicy[0].amount, this.partialPaymentCancellationPolicy[0].currency);
         var firstDatePriceTextBold = "<span style='font-weight: 600;'>" + firstDepositPriceText + "</span>";
         return this.$t("orderDetail_PartialPaymentDeadLineBody").replace("#VALUE#", firstDatePriceTextBold);
      },
      replaceCancellationPolicies() {
         var secondLine = `<li style="margin-bottom: 8px;">${this.$t("hotelCheckout_PartialCancellationContentText").replace(
            "#VALUE#",
            `<span style='font-weight: 600;'> ${this.formattedPartialPaymentLastBookingDate}</span>`
         )}</li>`;

         // var thirdLine = `<li style="margin-bottom: 8px;">${this.$t("orderDetail_PartialCancellationContentText3")
         //    .replace("#VALUE1#", `<span style="font-weight:600"> ${this.formattedFirstPaymentDate}</span>`)
         //    .replace("$VALUE2#", `<span style="font-weight:600"> ${this.formattedFirstPaymentDateTo}</span>`)
         //    .replace(
         //       "#VALUE#",
         //       `<span style="font-weight:600"> ${this.$options.filters.price(
         //          this.partialPaymentCancellationPolicy[0].value,
         //          this.partialPaymentCancellationPolicy[0].currency
         //       )} </span>`
         //    )}</li>`;

         var mainText = `<div style='display:flex; flex-direction: column;'><ul>${secondLine}</ul></div>`;

         return mainText;
      },
      formattedPartialPaymentLastBookingDate() {
         return moment(this.partialPaymentLastBookingDate).format("DD.MM.YYYY HH:mm");
      },
      formattedFirstPaymentDate() {
         return moment(this.partialPaymentCancellationPolicy[0].fromDate).format("DD.MM.YYYY HH:mm");
      },
      formattedFirstPaymentDateTo() {
         return moment(this.partialPaymentCancellationPolicy[0].toDate).format("DD.MM.YYYY HH:mm");
      },
      formattedSecondPaymentDate() {
         return moment(this.partialPaymentCancellationPolicy[1].fromDate).format("DD.MM.YYYY HH:mm");
      },
      formattedSecondPaymentDateTo() {
         return moment(this.partialPaymentCancellationPolicy[1].toDate).format("DD.MM.YYYY HH:mm");
      },
      CountryCode() {
         return this.countryCode;
      },
      roomList() {
         return this.roomsList;
      },
      TotalPriceInfo() {
         return { ...this.totalPriceInfo, ...this.ProviderPriceInfo };
      },
      cancellationPolicy() {
         return this.cancellationPolicies;
      },
      cancellationPolicyDate() {
         return this.cancellationPoliciesDate;
      },
      DefaultAgencyCommissionRatio() {
         return this.agencyCommission.options.indexOf(this.agencyCommission.options.find((option) => option.value == 0.1));
      },
      hotelName() {
         return this.$parent.$parent._data.hotelInformation.name;
      },
      ProviderPriceInfo() {
         return this.providerPriceInfo ? this.providerPriceInfo : {};
      },
   },
   created() {
      this.startupGetAddons();
      this.emitSelectedAddOns();
   },

   watch: {
      "checkoutRequestModel.selectedAddOns": {
         handler() {
            this.emitSelectedAddOns();
         },
         deep: true,
      },
      roomList: {
         handler: function (newValue) {
            var self = this;
            self.rooms = [];
            newValue.map((roomItem) => {
               const roomObj = {
                  roomIdentifier: roomItem.roomIdentifier,
                  guests: roomItem.guests,
               };
               self.rooms.push(roomObj);
               this.$emit("update-to-rooms", self.rooms);
            });

            self.checkoutRequestModel.rooms = self.rooms;
         },
         deep: true,
      },
      checkoutRoomGuest: {
         handler: function (newValue) {
            var self = this;
            self.roomsPaxes = newValue;
         },
         deep: true,
      },
      checkoutUuidProps: function (value) {
         const self = this;
         self.checkoutRequestModel.checkoutUuid = value;
      },
      searchUuidProps: function (value) {
         const self = this;
         self.checkoutRequestModel.searchUuid = value;
      },
      partialPaymentActive: {
         handler(newVal) {
            if (newVal) {
               this.handleSelectedInsurance("");
            }
         },
         deep: true,
      },
   },
   methods: {
      startupGetAddons(addons) {
         this.checkoutRequestModel.selectedAddOns = addons;
      },
      emitSelectedAddOns() {
         this.$emit("update-selectedAddOns", this.checkoutRequestModel.selectedAddOns);
      },

      getAgencyCommisions(coms) {
         this.agencyCommisionsModel = coms;
      },
      handleSelectedInsurance(identifier) {
         this.$store.commit("app/setIsProgressGifActive", true);

         const self = this;
         this.$emit("selected-insurance", identifier);
         self.checkoutRequestModel.searchUuid = this.$route.params.uuid;
         self.checkoutRequestModel.basketUuid = this.$route.params.basketuuid;
         self.checkoutRequestModel.contact = this.contactModel;
         self.checkoutRequestModel.selectedInsurance = identifier;
         self.checkoutRequestModel.rooms = this.roomsList;

         this.$store.state.app.progress.message = this.$i18n.t("hotelCheckout_insuranceLoading");
         hotelService.hotelCheckout(self.checkoutRequestModel).then((response) => {
            this.checkinDate = response.checkinDate;
            this.checkoutDate = response.checkoutDate;
            var diffDate = moment(this.checkoutDate).diff(moment(this.checkinDate), "days");

            var checkoutBasketModel = {
               rooms: response.rooms,
               diffDate: diffDate,
               totalAmount: response.totalPrice,
               selectedInsuranceTotal: response.totalPrice.insuranceTotal,
               isCheckoutBasket: true,
               hotelInformation: {
                  name: response.hotelName,
                  address: response.hotelAddress,
                  star: response.hotelStar,
               },
            };

            if (response.insuranceOffers && response.insuranceOffers.some((offer) => offer.selected)) {
               Popup.info(this.$i18n.t("Insurance_lblPaymentMethodChange"), this.$i18n.t("Insurance_txtCannotReserveWithInsurance"));
            }

            this.$store.commit("hotel/updateBasketResponse", checkoutBasketModel);

            this.$parent.$parent.totalPrice = response.totalPrice;
            this.$parent.$parent.checkoutResponse = response;
            this.$store.commit("app/setIsProgressGifActive", false);
         });
      },
      handleUpdateAddons(addons) {
         this.$store.commit("app/setIsProgressGifActive", true);

         const self = this;
         self.checkoutRequestModel.selectedAddOns = addons;
         self.checkoutRequestModel.searchUuid = this.$route.params.uuid;
         self.checkoutRequestModel.basketUuid = this.$route.params.basketuuid;
         self.checkoutRequestModel.contact = this.contactModel;
         self.checkoutRequestModel.rooms = this.roomsList;
         self.checkoutRequestModel.agencyCommissionRatio = this.agencyCommisionsModel.agencyCommissionRatio;
         self.checkoutRequestModel.agencyCommissionExtra = this.agencyCommisionsModel.agencyCommissionInputValue;
         this.checkoutRequestModel.refreshCheckout = true;

         hotelService.hotelCheckout(self.checkoutRequestModel).then((response) => {
            this.checkinDate = response.checkinDate;
            this.checkoutDate = response.checkoutDate;
            var diffDate = moment(this.checkoutDate).diff(moment(this.checkinDate), "days");

            var checkoutBasketModel = {
               rooms: response.rooms,
               diffDate: diffDate,
               totalAmount: response.totalPrice,
               selectedInsuranceTotal: response.totalPrice.insuranceTotal,
               isCheckoutBasket: true,
               hotelInformation: {
                  name: response.hotelName,
                  address: response.hotelAddress,
                  star: response.hotelStar,
               },
            };
            this.$store.commit("hotel/updateBasketResponse", checkoutBasketModel);

            this.$parent.$parent.rooms = response.rooms;
            //this.roomsList = response.rooms;
            this.$parent.$parent.totalPrice = response.totalPrice;
            this.$parent.$parent.checkoutResponse = response;
            this.$store.commit("app/setIsProgressGifActive", false);
         });
         this.emitSelectedAddOns();
      },
      handlerAddCommission(agencyCommissionInfo) {
         const self = this;
         const { type } = agencyCommissionInfo;
         const { agencyCommissionExtra, agencyCommissionRatio } = agencyCommissionInfo.agencyCommission;
         self.checkoutRequestModel.searchUuid = this.$route.params.uuid;
         self.checkoutRequestModel.basketUuid = this.$route.params.basketuuid;
         self.checkoutRequestModel.contact = this.contactModel;
         self.checkoutRequestModel.rooms = this.roomsList;

         // console.log(agencyCommissionInfo);
         if (type === "select" && this.isFirstRender) {
            this.isFirstRender = false;
            this.checkoutRequestModel.refreshCheckout = false;
         }
         switch (type) {
            case "select": {
               self.checkoutRequestModel.agencyCommissionRatio = agencyCommissionRatio;
               break;
            }

            case "input": {
               const agencyCommissionInputValue = Number(agencyCommissionExtra);
               self.checkoutRequestModel.agencyCommissionRatio = agencyCommissionRatio;
               self.checkoutRequestModel.agencyCommissionExtra = agencyCommissionInputValue;
               break;
            }
         }

         // for prevent users to enter negative value
         if (this.checkoutRequestModel.agencyCommissionExtra < 0) {
            this.checkoutRequestModel.agencyCommissionExtra = 0;
            return;
         }
         if (type === "select" && this.isFirstRender) {
            this.isFirstRender = false;
            this.checkoutRequestModel.refreshCheckout = false;
            this.$store.commit("app/setIsProgressGifActive", false);
         } else {
            this.checkoutRequestModel.refreshCheckout = true;
            this.$store.commit("app/setIsProgressGifActive", true);
         }
         this.$store.state.app.progress.message = this.$i18n.t("hotelCheckout_agencyExtraCCommission");
         hotelService.hotelCheckout(self.checkoutRequestModel).then((response) => {
            this.checkinDate = response.checkinDate;
            this.checkoutDate = response.checkoutDate;
            var diffDate = moment(this.checkoutDate).diff(moment(this.checkinDate), "days");

            var checkoutBasketModel = {
               rooms: response.rooms,
               diffDate: diffDate,
               totalAmount: response.totalPrice,
               selectedInsuranceTotal: response.totalPrice.insuranceTotal,
               isCheckoutBasket: true,
               hotelInformation: {
                  name: response.hotelName,
                  address: response.hotelAddress,
                  star: response.hotelStar,
               },
            };
            this.$store.commit("hotel/updateBasketResponse", checkoutBasketModel);

            this.$parent.$parent.rooms = response.rooms;
            //this.roomsList = response.rooms;
            this.$parent.$parent.totalPrice = response.totalPrice;
            this.$parent.$parent.checkoutResponse = response;
            this.$store.commit("app/setIsProgressGifActive", false);
         });
      },
   },
};
</script>

<style lang="scss" scoped>
.room-info-section {
   .checkout-section-inner {
      .room-info-item {
         margin-bottom: 32px;
         padding-bottom: 32px;
         background-image: linear-gradient(to right, #000 50%, rgba(255, 255, 255, 0) 50%);
         background-position: bottom;
         background-size: 10px 2px;
         background-repeat: repeat-x;

         &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            background-image: none;
         }
      }
      &.room-info-card {
         margin-bottom: 40px;
         .checkout-section-title {
            &.masked {
               width: 60%;
            }
         }
         @media (max-width: 767.98px) {
            .checkout-section-title {
               &.masked {
                  width: auto;
               }
            }
         }
      }
      &.room-info-price {
         margin-top: 2rem;
      }
   }
   .room-alert-wrapper {
      margin-bottom: 8px;
      ::v-deep i {
         // width: 40px !important;
         margin-right: 8px;
         filter: invert(79%) sepia(93%) saturate(1003%) hue-rotate(338deg) brightness(100%) contrast(81%);
      }
      ::v-deep .room-alert-inner {
         p {
            color: #363940;
            font-size: 14px;
            font-weight: 700;

            & > span {
               margin-right: 8px;
               font-size: 20px;
               font-weight: 900;
            }
         }
      }
   }
}
</style>
